import { BaseController } from '../../../common/base/controller';
import _ from 'lodash';

export class TicketOverviewController extends BaseController {
  constructor(
    controllerService,
    ticketFlowService,
    ticketStateName,
    ticketService,
    reportService,
    ticketsChartService,
    ticketTableService,
    $scope,
    TicketListBreadcrumbs,
    TicketFilterService,
  ) {
    'ngInject';
    super({
      controllerService,
      ticketFlowService,
      ticketStateName,
      ticketService,
      reportService,
      ticketsChartService,
      ticketTableService,
      $scope,
      TicketListBreadcrumbs,
      TicketFilterService,
    });
  }

  get filterService() {
    return this.TicketFilterService;
  }

  get tableStateKey() {
    return this.ticketTableService.getTableStateKey(this.ticketsType);
  }

  get hideChart() {
    return this.isKWS;
  }

  $onInit() {
    const { filterService } = this;
    filterService.ticketsType = this.ticketsType;

    // Generate breadcrumbs
    this.breadcrumbs = this.TicketListBreadcrumbs[filterService.ticketsType];
    this.currentBreadcrumb = this.breadcrumbs[1];

    // Read url parameter for target page of the tickets table
    const { page, searchTerm } = this.$stateParams;
    if (page) {
      this.ticketListPage = page;
    }

    // Get stored table state for search and filter values
    this.tableState = this.ticketTableService.getTableState(this.tableStateKey);

    // Initialize ticket list & build chart by setting filter type
    filterService.setFilterType(filterService.filterTypes.states);

    // Update chart when tickets has been loaded
    this.$scope.$on('ticketTableUpdated', (event, update) =>
      this.ticketTableUpdated(update),
    );

    if (searchTerm) {
      this.searchInputs = [];
      for (let i in searchTerm) {
        let value = searchTerm[i].replace(/ /g, ''); // because search didn't work with whitespaces and I waste much time. Awesome.
        this.searchInputs.push({
          type: 'text',
          value,
          key: null,
          valueAddition: null,
        });
      }
    }
  }

  ticketTableUpdated(update) {
    this.$log.debug('ticketTableUpdated', { update });
    this.filterService.setFilterables(update.totalCounts);

    // Build chart of ticket states when disable feature is not activated
    if (!this.isFeatureActive(this.FeatureNames.FF_DISABLE_TICKET_LIST_CHART)) {
      this.buildChart(update);
    }
  }

  /**
   * Broadcast a `refreshTable` event to initiate a ticket update
   * by the actually configured filter settings.
   */
  updateTickets(options) {
    this.$log.debug('updateTickets broadcasting "refreshTable"');
    this.$scope.$broadcast('refreshTable', options);
  }

  handleUpdateFilter($event, options) {
    this.filterService.handleUpdateFilter($event, options);
    this.updateTickets(this.filterService.headerOptions);
  }

  buildChart(update) {
    const states = this.filterService.getValidStatesForFilterType();
    this.chartData = this.ticketsChartService.getChartData(
      update.totalCounts,
      this.currentFilterType,
      this.filterService.filterTypes,
      states,
    );
  }

  hide(ticket) {
    this.ticketService
      .hide(ticket.id, this.filterService.ticketsType)
      .then(() => {
        _.remove(this.allTickets, ticket);
        this.updateTickets();
      });
  }

  downloadTicketProgression(since) {
    const { reportService } = this;
    reportService
      .downloadTicketProgression(since, this.$stateParams.product)
      .busy(this, 'downloadTicketProgressionBusy');
  }

  downloadBafinReport() {
    const { reportService } = this;
    reportService.downloadBafinReport().busy(this, 'downloadBafinReportBusy');
  }

  newTicket() {
    const route = this.ticketFlowService.getCreateRoute(
      this.filterService.ticketsType,
    );
    if (route) {
      this.go(route);
    }
  }

  updateTicketTable(options) {
    this.filterService.headerInput(options);
    this.updateTickets(options);
  }
}
